import { render } from "./PlayerHand.vue?vue&type=template&id=182fe0aa&scoped=true"
import script from "./PlayerHand.vue?vue&type=script&lang=js"
export * from "./PlayerHand.vue?vue&type=script&lang=js"

import "./PlayerHand.vue?vue&type=style&index=0&id=182fe0aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182fe0aa"]])

export default __exports__